module.exports = __webpack_public_path__ + "static/media/ic-arrow-down-white.213e09bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-down-white.svg
// module id = 589
// module chunks = 14